import React, { useState } from 'react';
import isEmpty from 'lodash/isEmpty';

import { MaterialsListItemSkuMaterial } from './MaterialsListItemSku.types';

import { Translate } from '../../../../../../../helpers/Translate';
import { Tooltip } from '../../../../../../../helpers/tooltips/Tooltip';
import { TooltipPlacement } from '../../../../../../../helpers/tooltips/tooltipsConstants';

import { words } from '../../../../../../../locales/keys';

interface MaterialsListItemSkuProps {
  material: MaterialsListItemSkuMaterial;
}

function MaterialsListItemSku({ material }: MaterialsListItemSkuProps) {
  const [referenceTooltipElement, setReferenceTooltipElement] =
    useState<HTMLSpanElement | null>(null);

  if (isEmpty(material.sku)) {
    return null;
  }

  return (
    <div
      className="text-gray-600 dark:text-gray-500 text-2xs truncate"
      ref={setReferenceTooltipElement}
    >
      <span>
        <Translate id={words.sku} />
        {': '} {material.sku}
      </span>

      <Tooltip
        withArrow
        placement={TooltipPlacement.TOP}
        referenceElement={referenceTooltipElement}
        tooltipText={material.sku}
        interactive
      />
    </div>
  );
}

export default MaterialsListItemSku;
